module.exports = {"subtitle":"An interactive introduction to stereonets.","geocompassTab":"Compass","stereonetTab":"Stereonet","contextTab":"3D View"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/layout/en/messages.json
// module id = 298
// module chunks = 0